export default {
    slug: 'vouchers',
    title: 'Vouchers',
    visible: [
        'id',
        'number',
        'template.title',
        'contact.customer_number',
        'contact.full_name',
        'contact.company_name',
        'user.full_name'
    ],
    listview: 'VouchersListView',
    locales: ['common'],
    columns: [],
    templates: {
        amount(row) {
            if (row.amount !== undefined) {
                return row.amount.toFixed(2) + ' €';
            } else {
                return 0.00 + ' €';
            }
        },
        'parent_voucher.amount': (row) => {
            return row.parent_voucher ? (row.parent_voucher.amount.toFixed(2) + ' €') : '-';
        },
        consumption(row) {
            return parseFloat(row.consumption ? row.consumption : 0).toFixed(2) + ' €';
        },
        consumption_tip(row) {
            return parseFloat(row.consumption_tip ? row.consumption_tip : 0).toFixed(2) + ' €';
        }
    },
    actions: {
        showDetails: {
            title: 'Show Details',
            level: 'row',
            vm: 'showDetails'
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/store/vouchers/main/state.js